import { useId } from 'react';

import { PieChart, Pie, Cell } from 'recharts';

import styles from './chartpie.module.scss';

interface ChartPieProps {
	plannedSeconds: number;
	reservedCapacityRatio: number;
	availableSeconds: number;
}

export function ChartPie({ plannedSeconds, reservedCapacityRatio, availableSeconds }: ChartPieProps) {
	const patternId = useId();
	const utilizedFraction = availableSeconds > 0 ? plannedSeconds / availableSeconds : 0;
	const remainder = Math.max(0, 1 - utilizedFraction - reservedCapacityRatio);
	const data = [
		{ name: 'utilized', value: utilizedFraction },
		{ name: 'reserved', value: reservedCapacityRatio },
		{ name: 'remainder', value: remainder }
	];

	return (
		<div className={styles['container']}>
			<PieChart width={78} height={78}>
				<defs>
					<pattern id={patternId} patternUnits="userSpaceOnUse" width="8" height="8">
						<rect width="8" height="8" fill="#E1E9F0" />
						<path d="M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4" stroke="#CBD5E0" strokeWidth="3" />
					</pattern>
				</defs>
				<Pie
					data={data}
					cx="50%"
					cy="50%"
					innerRadius={18}
					outerRadius={39}
					startAngle={90}
					endAngle={-270}
					dataKey="value"
					stroke="none"
					isAnimationActive={false}
				>
					<Cell fill="#3091CE" />
					<Cell fill={`url(#${patternId})`} />
					<Cell fill="#E1E9F0" />
				</Pie>
			</PieChart>
		</div>
	);
}

export default ChartPie;
